var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLoading)?_c('div',{staticClass:"hc-loading",class:{ 'hc-mask': _vm.full }},[_c('fa-icon',{attrs:{"icon":"asterisk","size":"3x","spin":""}}),_c('div',{staticClass:"h5 mt-3"},[_vm._v(_vm._s(_vm.loadingText))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }